const API_URL = 'https://api.yummly.com/v1/api/recipes?';
const RECIPE_URL = 'https://api.yummly.com/v1/api/recipe/';

const ID = '2c80b334';
const KEY = 'bf5c0c89d4fc90c63f3dc60f69314e05';


export default {
  API_URL,
  RECIPE_URL,
  ID,
  KEY,
};



// WEBPACK FOOTER //
// ./src/lib/API.js